module.exports = __webpack_public_path__ + "static/img/bt1.203f1925.png";